module.exports = __webpack_public_path__ + "static/media/whiteTrashCan.a912fa36.svg";